module.exports = __webpack_public_path__ + "e741e656431943d23fa99f20ac923eb3.png";